import { OnInit, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {ServicioImprimirAdmisionService, ParametrosImprimirAdmisionEntity, InformacionUsuarioEntity} from 'src/app/services/servicio-imprimir-admision.service';
import {
  // tslint:disable-next-line: max-line-length
  ServicioNotificacionDevolucionMedicamentosService, ParametrosNotificacionDevolucionMedicamentosEntity, EntidadEmpresarial, DataEncabezadoSolicitudSuministrosEntity, DataSolicitudSuministrosBodyEntity
} from 'src/app/services/servicio-notificacion-devolucion-medicamentos.service';
import { HttpErrorResponse } from '@angular/common/http';
import { debug } from 'util';

@Component({
  selector: 'app-reporte-notificacion-devolucion',
  templateUrl: './reporte-notificacion-devolucion-medicamentos.component.html',
  styleUrls: ['./reporte-notificacion-devolucion-medicamentos.component.css']
})
export class ReporteNotificacionDevolucionMedicamentosComponent implements OnInit {

  loading: boolean;
  session: boolean;
  totalItems: number;
  descripcionBodega: string;
  filtrosSeleccionados: any;
  fechaImpresion: Date;
  datosBaseResolucionEntity: any;
  user: string;
  dataDevoluciones: DataSolicitudSuministrosBodyEntity[] = [];
  dataEncabezadoDevoluciones: DataEncabezadoSolicitudSuministrosEntity = {
    descripcionSede: '',
    consecutivoAdm: '',
    nombreAfiliado: '',
    numeroIdentificacion: '',
    codigo: ''
  };

  public parametrosNotificacionDevolucionMedicamentos: ParametrosNotificacionDevolucionMedicamentosEntity = {
    codigoBaseDatos: '',
    uncoSede: '',
    uncoLogin: 0,
    uncoEntidad: 0,
    uncoAdm: 0
  };

  public entidadEmpresarial: EntidadEmpresarial = {
    unco: 0,
    nombreEntidad: '',
    nit: '',
    digitoVerificacion: '' ,
    direccion: '',
    telefono: '',
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private servicioNotificacionDevolucionMedicamentos: ServicioNotificacionDevolucionMedicamentosService,
    private servicioAdmision: ServicioImprimirAdmisionService) {
    this.activatedRoute.params.subscribe(params => {

      this.parametrosNotificacionDevolucionMedicamentos.codigoBaseDatos = params['codigoBaseDatos'];
      this.parametrosNotificacionDevolucionMedicamentos.uncoSede = params['uncoSede'];
      this.parametrosNotificacionDevolucionMedicamentos.uncoEntidad = params['uncoEntidad'];
      this.parametrosNotificacionDevolucionMedicamentos.uncoLogin = params['uncoLogin'];
      this.parametrosNotificacionDevolucionMedicamentos.uncoAdm = params['uncoAdm'];

    });
  }

  ngOnInit() {

    this.session = true;

    const status = this.getParameterByName('status');

        // tslint:disable-next-line: triple-equals
        if (status == 'true') {
          window.addEventListener('message', (event) => {

            try {

              const data = JSON.parse(event.data);
              // tslint:disable-next-line: triple-equals
              if (undefined != data.origin) {

                if (event.source instanceof Window) {
                  event.source.postMessage('OK', event.origin);
                }

                // event.source.postMessage('OK', event.origin);
                this.getInfoUsuario();
                this.getDataEncabezado();
                this.getData(data.data);
                this.session = false;

                localStorage.setItem('data', data.data);

                const currURL = window.location.href;
                const keyParam = 'status';
                const value = false;
                const currentURL = window.location.href;

                if (currURL.indexOf('?') !== -1) {
                  window.history.replaceState('', '', currentURL.slice(0, - 12) + '?' + keyParam + '=' + value);
                }

              }
            } catch (e) {
              if (event.source instanceof Window) {
                event.source.postMessage('OK', event.origin);
              }
              // event.source.postMessage(JSON.stringify(e), event.origin);
            }

          }, false);

        } else {

          this.getInfoUsuario();
          this.getDataEncabezado();
          this.getData(localStorage.getItem('data'));
          this.session = false;
        }

  }

  getParameterByName(name: string) {

		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, "\\]");

		let regex = new RegExp("[\\?&]" + name + "=([^&#]*)"), results = regex.exec(window.location.href);

		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));

  }

  setDataEntidad(param: any) {
    this.entidadEmpresarial = param;
  }

  async getData(json: string) {

    try {

      this.getJsonMedicamentos();

      const response = await this.servicioNotificacionDevolucionMedicamentos.getDataReporte(this.parametrosNotificacionDevolucionMedicamentos.codigoBaseDatos,
        this.parametrosNotificacionDevolucionMedicamentos.uncoAdm, json);

      if (response != null) {
        response.subscribe((data: DataSolicitudSuministrosBodyEntity[]) => {

          this.dataDevoluciones = data;
          this.descripcionBodega = data.length > 0 ?  data[0].descripcionBodega : '';
          this.totalItems = data.length;

          this.loading = false;
        }, (err: HttpErrorResponse) => {
          console.error(err);
          this.loading = false;
        });
      }
    } catch (e) {
      console.error(e);
      this.loading = false;
    }

  }

  getJsonMedicamentos() {

    /*const ventana = window.open(this.nameDominio +'/'+ this.path + '/', ``, 'width=200, height=100');
    ventana.postMessage('test',)
    let json = '[]';
    if (ventana) {
      json = ventana.localStorage.getItem('dataSum');
      ventana.close();
      console.log(json);
    }

    return json;*/
  }

  async getDataEncabezado() {

    try {

      const response = await this.servicioNotificacionDevolucionMedicamentos.getDataEncabezado(this.parametrosNotificacionDevolucionMedicamentos.codigoBaseDatos,
        this.parametrosNotificacionDevolucionMedicamentos.uncoAdm);

      if (response != null) {
        response.subscribe((data: DataEncabezadoSolicitudSuministrosEntity[]) => {
          if (data.length > 0) {
            this.dataEncabezadoDevoluciones = data[0];
          }
          this.loading = false;

        }, (err: HttpErrorResponse) => {
          console.error(err);
          this.loading = false;
        });
      }
    } catch (e) {
      console.error(e);
      this.loading = false;
    }

  }

  async getInfoUsuario() {

    const parametrosUrl: ParametrosImprimirAdmisionEntity = {
      codigoBaseDatos: this.parametrosNotificacionDevolucionMedicamentos.codigoBaseDatos,
      uncoSede: '',
      uncoLogin: this.parametrosNotificacionDevolucionMedicamentos.uncoLogin + '',
      uncoAdmision: '',
      uncoAdmisionEmpresa : ``
    };

    const response = await this.servicioAdmision.getInformacionUsuario(parametrosUrl);

    if (response != null) {
      response.subscribe( (data: any) => {
        if (data != null) {
          this.user = data[0].nombreUsuario;
        }
      }, error => {
        this.loading = false;
        console.error(error);
      });
    }
  }

}
